import styled from 'styled-components';

import { colors, ds } from '@/config/colors';

/* Pola formularza KDS: wspólne dla parowania (PairKdsDevice) i modalu zmiany przypisania. */
export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => (theme.mode === 'dark' ? ds.borderStrong : ds.textSecondary)};
`;

export const Hint = styled.span`
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => (theme.mode === 'dark' ? ds.textMuted : ds.textSecondary)};
`;

export const Warning = styled.span`
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => (theme.mode === 'dark' ? colors.warning[400] : colors.warning[700])};
`;

/* Kropka koloru stanowiska: ta sama w selekcie i w kolumnie listy ekranów. */
export const StationDot = styled.span<{ $color?: string | null }>`
  display: inline-block;
  width: 10px;
  height: 10px;
  flex: 0 0 10px;
  border-radius: 50%;
  background: ${({ $color, theme }) => $color || (theme.mode === 'dark' ? colors.neutral[600] : ds.borderStrong)};
  box-shadow: 0 0 0 1px ${({ theme }) => (theme.mode === 'dark' ? colors.neutral[700] : ds.borderDefault)};
`;

export const OptionLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const OptionMuted = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.muted};
`;
